import { Directive, HostBinding, Input } from '@angular/core';
import { QualificationOutcome } from 'src/app/core/enums/lead/qualification-outcome.enum';

@Directive({
    selector: '[appLeadQualificationOutcomeIcon]',
    standalone: false
})
export class LeadQualificationOutcomeIconDirective {

  @Input() set outcome(outcome: QualificationOutcome) {
    this.iconType = this.getIconType(outcome)
    this.color = this.getIconColor(outcome)
  }

  @HostBinding('innerHTML') iconType = '';
  @HostBinding('style.color') color = ''

  private getIconType(outcome: QualificationOutcome): string {
    switch (outcome) {
      case QualificationOutcome.Interested: return 'thumb_up'
      case QualificationOutcome.NeverReplied:
      case QualificationOutcome.NonInterested: return 'thumb_down'
      default: return ''
    }
  }

  private getIconColor(outcome: QualificationOutcome): string {
    switch (outcome) {
      case QualificationOutcome.Interested: return '#65ad3c' // $repowerGreen
      case QualificationOutcome.NeverReplied:
      case QualificationOutcome.NonInterested: return '#ff463c' // $repowerRed
      default: return ''
    }
  }

}
